import styled from "@emotion/styled";
import { Col } from "antd";
import { genericStyles } from "../../../../constant";

export const StyledProductivityHub = styled(Col)`
  transition:
    flex 0.35s cubic-bezier(0.4, 0, 0.2, 1),
    max-width 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  background: #f9fafb;
  position: relative;

  .productivity-header {
    padding: 10px 10px;
    h2 {
      font-weight: 500;
    }
    h4 {
      margin: 0 !important;
    }
  }
  .anticon-plus {
    font-size: 16px;
  }
  .productivity-body {
    overflow: auto;
    height: calc(100% - 125px);
  }

  .ant-tabs-nav {
    padding: 0px 10px;
  }

  .productivity-tabs {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;
  }

  .ant-tabs-content,
  .ant-tabs-tabpane {
    height: inherit;
  }
  .ant-tabs-content-holder {
    flex: 1;
    overflow: auto;
    height: 100%;
  }

  .notes-body {
    height: inherit;
    .notes-collapse {
      overflow: auto;
      flex: 1;
      margin-bottom: 0px !important;
    }

    .notes-content {
      .note-item {
        background: #ffffff;
        border: 1px solid #f0f0f0;
        border-radius: 8px;
        padding: 12px 14px;
        margin-bottom: 12px;
      }

      .note-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
      }

      .note-author {
        font-weight: 500;
        font-size: 12px;
        color: #141414;
      }

      .note-time {
        font-size: 11px;
        color: #8c8c8c;
      }

      .note-content {
        font-size: 15px;
        color: #1f1f1f;
        line-height: 1.6;
        word-wrap: break-word;
      }
    }
    .notes-footer {
      padding: 12px 14px;
    }
  }
  .productivity-padding {
    padding: 0px 10px;
  }
  .reminders-div {
    .reminders-body {
      .reminder-item {
        border-left: 4px solid ${genericStyles.primaryColor};
        border-radius: 8px;
        padding: 5px 14px;
        margin-bottom: 14px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        transition: all 0.2s ease;
      }

      .reminder-item:hover {
        background-color: #f1f5f9;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      }

      .reminder-title {
        font-size: 15px;
        color: #1e293b;
        font-weight: 500;
        margin-bottom: 8px;
        line-height: 1.5;
      }

      .reminder-date {
        width: 100%;
        font-size: 11px;
        color: #64748b;
        font-weight: 500;
      }
    }
  }
  .checklist-body {
    height: inherit;
    .checklist-collapse {
      overflow: auto;
      flex: 1;
      margin-bottom: 0px !important;
    }
    .checklist-content {
      background: #ffffff;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      .ant-checkbox-label,
      .ant-checkbox-wrapper {
        width: 100%;
      }

      .checklist-item {
        padding: 12px 10px;
        border-bottom: 1px solid #f0f0f0;
        transition: background-color 0.2s ease;
      }

      .check-point {
        width: calc(100% - 30px);
      }

      .checklist-item:hover {
        background-color: #fafafa;
        border-radius: 4px;
      }
    }
    .checklist-footer {
      padding: 12px 14px;
    }
  }
  .reminder-footer {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 68px;
    justify-content: space-around;
    padding: 0 20px;
    border-top: 1px solid #eaeaea;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);

    button {
      font-size: 18px;
    }
  }
`;
